module.exports = __webpack_public_path__ + "static/media/Twitter.0b9ff846.svg";